export default {
  lang: 'Español',
  refresh: 'Actualizar',
  back: 'Atrás',
  fullscreen: 'Pantalla Completa',
  exitfullscreen: 'Cerrar',
  browserecords: 'Visitados',
  login: 'Iniciar Sesión',
  logout: 'Salir',
  username: 'Usuario',
  password: 'Contraseña',
  failedlogin: 'Inicio de sesión no válido',
  failedloginmessage: 'Intente iniciar sesión nuevamente',
  404: 'Cuando ve esta página, significa que el servidor no puede encontrar la página que necesita ...',

  menu: require('./menu'),
  message: require('./message'),
  name: require('./name')
}